import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./AiChatPage.css";



export default function AiChatPage() {
  const { persona } = useParams();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);

  const personaName = persona === "adam" ? "Adam" : "Eve";

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { sender: "user", text: input }];
    setMessages(newMessages);

    try {
      const res = await axios.post("http://localhost:5003/api/ai/chat", {
        message: input,
        persona,
      });

      setMessages([...newMessages, { sender: "ai", text: res.data.reply }]);
    } catch (err) {
      setMessages([...newMessages, { sender: "ai", text: "⚠️ AI is not responding" }]);
    }

    setInput("");
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="ai-chat-container">

      {/* HEADER */}
      <div className="ai-chat-header">
        <img
          src={persona === "adam" ? "/boy.png" : "/girl.png"}
          alt={personaName}
          className="ai-avatar"
        />
        <h1>Chat with {personaName}</h1>
      </div>

      {/* CHAT BODY */}
      <div className="ai-chat-body">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`chat-message ${msg.sender === "user" ? "user-msg" : "ai-msg"}`}
          >
            <p>{msg.text}</p>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* INPUT BOX */}
      <div className="ai-input-area">
        <input
          type="text"
          placeholder={`Send a message to ${personaName}...`}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}
